import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function AvatarUpload({ src, onChange }) {
  const fileRef = useRef();

  const handleClick = () => {
    fileRef.current.click();
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      onChange(e.target.files[0]); // Pass file to parent
    }
  };

  return (
    <div
      className={`avatar-upload-wrapper ${src !== null ? "has-image" : "no-image"}`}
      onClick={handleClick}
    >
      <img src={src} alt="" className="avatar-image" />

      <div className="avatar-overlay pt-3">
        <FontAwesomeIcon icon="camera" className="text-secondary" />
        <p className="text-xxs text-secondary mt-1">Upload Photo</p>
      </div>

      <input
        type="file"
        ref={fileRef}
        accept="image/*"
        onChange={handleFileChange}
        className="d-none"
      />
    </div>
  );
}
